import { axios } from "~/plugins/request"
export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
  initProductChangeOrderList({commit}, params) {                  // 列表页列表数据
		return new Promise((resolve, reject) => {
      let orderList = axios.post('/productChange/findChangeOrder', params)
      let orgTree = axios.get('/org/findOrgTreeByCurrentUser')
      Promise.all([orderList, orgTree])
			.then(res => {
				resolve(res)
			}).catch(error=> {
				reject(error)
			})
    })
  },
  findRefundOrder({commit}, params) {                              // 查询可产品变更的销售订单列表
		return new Promise((resolve, reject) => {
      axios.post('productChange/findChangeOrder', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findRefundOrder({commit}, params) {                              // 查询可产品变更的销售订单列表
		return new Promise((resolve, reject) => {
      axios.post('refund/findRefundOrder', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findSalesOrder({commit}, params) {                              // 查询可产品变更的销售订单列表
		return new Promise((resolve, reject) => {
      axios.post('productChange/findProductChangeOrder', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findSaveOrder({commit}, params) {                                // 新建时获取销售订单部分信息
		return new Promise((resolve, reject) => {
      axios.post('productChange/findChangeOrderById', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveChangeOrder({commit}, params) {                               // 保存、提交产品变更信息
    return new Promise((resolve, reject) => {
      axios.post('productChange/saveChangeOrder', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findChangeOrderById({commit}, params) {                           // 根据产品变更订单ID获取产品变更订单详情 用于查看或者编辑
    return new Promise((resolve, reject) => {
      axios.post('productChange/findChangeOrderById', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteProductChangeOrder({ commit }, params) {
    return new Promise((resolve,reject) => {
      axios.post('/productChange/changeDelete', params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  approval({ commit }, params){
    return new Promise((resolve,reject) => {
      axios.post('/productChange/approveChangeOrderStart', params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  findChangeOrder({ commit }, params){
    return new Promise((resolve,reject) => {
      axios.post('/productChange/findChangeOrder', params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  withdrawOrder({ commit }, params){
    return new Promise((resolve,reject) => {
      axios.post('/workflowApproval/workflowRecall', params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
}